import axios from "axios";
import { useEffect, useState } from "react";
import InlineTabularForm from "./common/inline-tabular-form/inlineTabularForm";
import qs from "qs";
import dataProvider from "../../../../../services/dataProvider";
import authServices from "../../../../../services/authServices";
import { Link } from "react-router-dom";
import { FORMS_ROUTE } from "../../../dashboard-routes";
import { DASHBOARD_ROUTE } from "../../../../../routes";
import { markTaskComplete } from "../../../common/mark-task-complete";
import AssociatedTask from "../../../common/associated-task";
import getAssociatedTask from "../getAssociatedTask";

export const schema = {
    timestamp: {
        name: "Complaint Number",
        type: "text",
        placeholder: "Enter Complaint Number",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    dateRecieved: {
        name: "Date Recieved",
        type: "date",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    natureOfComplaint: {
        name: "Nature of complaint",
        type: "text",
        placeholder: "Enter Nature of complaint",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    licenseeSignature: {
        name: "Licensee Signature",
        type: "text",
        placeholder: "Enter Licensee Signature",
        style: {
            minWidth: "20ch",
        },
    },
    actionTaken: {
        name: "Action Taken",
        type: "text",
        placeholder: "Action Taken",
        style: {
            minWidth: "20ch",
        },
    },
    SG7ComplaintFormFile: {
        name: "Complaint Form File",
        type: "file",
        placeholder: "",
        style: {
            minWidth: "26ch",
        },
    },
};

const SG7ComplaintFormRegister = ({ formType, formTitle }) => {
    const [inlineFormState, setInlineFormState] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [isUpdating, setIsUpdating] = useState(false);


    function cleanupData(data) {
        let cleanDataList = [];
        data.forEach((row) => {
            let cleanRow = {};
            Object.keys(schema).forEach((field) => {
                cleanRow[field] = row[field];
            });
            cleanRow.id = row.id;
            cleanDataList.push(cleanRow);
        });

        return cleanDataList;
    }

    useEffect(() => {
        setIsFetching(true);
        var data = qs.stringify({
            formType,
            isInline: true,
        });

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "inlineForms-getInlineFormsByFormType",
            headers: {
                orgid: authServices.getOrgId(),
                token: authServices.getToken(),
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if (response.data.status === "success") {
                    let cleanData = cleanupData(response.data.data);
                    setInlineFormState(cleanData);
                } else {
                    setIsFetching(false);
                }
            })
            .catch(function (error) {
                setIsFetching(false);
                setErrorMsg(error.message);
                console.error(error);
            });
    }, []);

    function onSubmit(formState) {
        var FormData = require("form-data");
        var data = new FormData();
        let jsonData = {};
        setIsUpdating(true);
        setSuccessMsg("");
        setErrorMsg("");

        data.append("formType", formType);
        data.append("formTitle", formTitle);
        jsonData["formType"] = formType;

        for (var key in formState) {
            data.append(key, formState[key]);
            jsonData[key] = formState[key];
        }

        //console.log(jsonData);

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "inlineForms-addInlineFormDetails",
            headers: {
                orgid: authServices.getOrgId(),
                token: authServices.getToken(),
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                //console.log("Inline Form Add", response.data);
                if (response.data.status === "success") {
                    setSuccessMsg("New Entry Recorded");
                    setInlineFormState(response.data.data);
                } else {
                    setErrorMsg("Something Went Wrong");
                }
                setIsUpdating(false);
            })
            .catch(function (error) {
                console.error(error);
                setErrorMsg(error.message);
                setIsUpdating(false);
            });
    }

    function onUpdate(formState) {
        var FormData = require("form-data");
        var data = new FormData();
        let jsonData = {};
        setIsUpdating(true);
        setSuccessMsg("");
        setErrorMsg("");

        data.append("editFormId", formState.id);
        data.append("formType", formType);
        data.append("formTitle", formTitle);

        jsonData["editFormId"] = formState.id;
        for (var key in formState) {
            data.append(key, formState[key]);
            jsonData[key] = formState[key];
        }

        //console.log("REC DATA", jsonData);

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "inlineForms-editInlineFormById",
            headers: {
                orgid: authServices.getOrgId(),
                token: authServices.getToken(),
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                //console.log("Inline Form Update", response.data);
                if (response.data.status === "success") {
                    setSuccessMsg("Entry Updated");
                    setInlineFormState(response.data.data);
                } else {
                    setErrorMsg("Something Went Wrong");
                }
                setIsUpdating(false);
            })
            .catch(function (error) {
                console.error(error);
                setErrorMsg(error.message);
                setIsUpdating(false);
            });
    }

    function onDelete(row) {
        //console.log("DELETE ROW", row);

        setIsUpdating(true);
        setSuccessMsg("");
        setErrorMsg("");

        var data = qs.stringify({
            formType,
            deleteFormId: row.id,
        });

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "inlineForms-deleteInlineFormByDocId",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                // console.log("Inline Form Delete", response.data);
                if (response.data.status === "success") {
                    setSuccessMsg("Entry Deleted");
                    if (response.data.data.length === 0) {
                        setInlineFormState((f) => {
                            //console.log("State", f);
                            return [];
                        });
                        setInlineFormState((f) => {
                            //console.log("State", f);
                            return [];
                        });
                    } else {
                        setInlineFormState(response.data.data);
                    }
                } else {
                    setErrorMsg("Something Went Wrong");
                }
                setIsUpdating(false);
            })
            .catch(function (error) {
                console.error(error);
                setErrorMsg(error.message);
                setIsUpdating(false);
            });
    }

    function onFileView(fileName) {
        var data = qs.stringify({
            filePath: fileName,
        });

        setIsUpdating(true);
        setErrorMsg("");

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "getFileUrlFromFilePath",
            headers: {
                token: authServices.getToken(),
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                setIsUpdating(false);
                //console.log("FILE URL FETCH", response);
                window.open(response.data.data[0], "_blank").focus();
            })
            .catch(function (error) {
                setIsUpdating(false);
                console.error("File Fetch", error);
                setErrorMsg(error.message);
            });
    }

    return (
        <div id="SGMonthlyChecklistLicenseeForm">
            <div className="container-fluid p-0">
                <div className="card p-4 m-0 no-radius border-0 border-bottom">
                    <h5 className="m-0">{formTitle}</h5>
                </div>
            </div>

            {successMsg && !errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-success m-0" role="alert">
                        {successMsg}
                    </div>
                </div>
            )}

            {errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-danger m-0" role="alert">
                        {errorMsg}
                    </div>
                </div>
            )}

           

            {isFetching ? (
                <div className="container-fluid p-3">
                    <div className="card p-3">
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Form Data</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container-fluid p-3">
                    <div className="card p-3">
                        <div className="d-flex justify-content-center">
                            <div className="w-100">
                                <div className="w-100">
                                    <InlineTabularForm
                                        isUpdating={isUpdating}
                                        onSubmit={onSubmit}
                                        onUpdate={onUpdate}
                                        onDelete={onDelete}
                                        onFileView={onFileView}
                                        data={inlineFormState}
                                        disableAddRow={true}
                                        schema={schema}
                                    />
                                    <Link
                                        className="text-decoration-none"
                                        to={DASHBOARD_ROUTE + FORMS_ROUTE + "/bucket-2/sg7-complaint-form"}
                                    >
                                        <div
                                            className="btn btn-light d-flex align-items-center justify-content-center"
                                            style={{
                                                backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23ccc' stroke-width='3' stroke-dasharray='8%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
                                            }}
                                        >
                                            <i className="material-icons me-3">add</i>
                                            <span style={{ textDecoration: "none" }}>Add Complaint</span>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SG7ComplaintFormRegister;
